import { useQuery } from "@tanstack/react-query";
import { useAuth } from "@/hooks/useAuth";
import { listMyConversations } from "@/lib/messaging";

/**
 * Total unread chat messages for the signed-in member. Messages are kept
 * completely separate from platform notifications, so this counts unread
 * conversation messages only.
 */
export function useUnreadMessages(): number {
  const { user } = useAuth();
  const userId = user?.id;
  const { data } = useQuery({
    queryKey: ["conversations", userId],
    enabled: Boolean(userId),
    queryFn: () => listMyConversations(userId!),
    refetchInterval: 30_000,
  });
  return (data ?? []).reduce((sum, c) => sum + c.unread, 0);
}
